// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export const TENANT_CHILDREN_MAX_COUNT = 4;

export const HARASSMENT_DETAILS_MAX_LENGTH = 900;
